// extracted by mini-css-extract-plugin
module.exports = {"mapArea":"jut__MapArea__mapArea"};